import React from 'react';
import queryString from 'query-string';

import { HotelRatingSquare, Link } from '@lt/components';
import classnames from 'classnames';
import { NBSP } from '../../../../constants/common';

import type { SearchParamsType } from '../../store/selectors/searchParams';

import styles from './hotelRelink.module.css';

interface IHotel {
  name: string;
  stars?: number;
  rating?: number;
  link: string;
}

export type RelinkHotelsType = Array<IHotel>;

interface IHotelRelink {
  hotels: RelinkHotelsType;
  searchParams: SearchParamsType;
  className?: string;
}

const getOpenLinkHandler = (searchParams) => (e) => {
  e.preventDefault();
  const hotelLink = e.currentTarget.href;

  const query = queryString.stringify(searchParams);

  window?.open(`${hotelLink.split('?')[0]}?${query}`, '_blank')?.focus();
};

const HotelRelink: React.FC<IHotelRelink> = (props) => {
  const { hotels, searchParams, className } = props;

  return (
    <div className={classnames(className, styles.container)}>
      {hotels.map((hotel) => (
        <Link
          className={styles.hotelLine}
          key={hotel.name}
          href={hotel.link}
          target="_blank"
          onClick={getOpenLinkHandler(searchParams)}
        >
          <div className={styles.hotelTitle}>
            <span>{hotel.name}</span>
            {NBSP}
            <span>{hotel.stars}</span>
            <span>{NBSP}★</span>
          </div>
          {hotel.rating ? (
            <HotelRatingSquare
              value={hotel.rating}
              count={hotel.rating}
              size="small"
            />
          ) : null}
        </Link>
      ))}
    </div>
  );
};

export default HotelRelink;
